import React, { useEffect, useState } from 'react'
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from '../Button/ButtonBlue'
import { useHistory } from 'react-router-dom'
import { staticFiles } from '../Helpers/Static'
import { Card } from '../../pages/Theme'
import { MdMap } from 'react-icons/md'
import { trimString } from '../Helpers/Common'
import WidgetOption from './WidgetOption'

const CROSS_GRAY_ICON = staticFiles.cross;

const ModalWidget = ({  show, 
                        setShow,
                        addPostLoader, 
                        onClick, 
                        dropdownOption, 
                        value, 
                        onChange,
                        failed,
                        buttonDisabled
                    }) => {

    const history = useHistory()
    const [selected, setSelected] = useState()
    // const [checked, setChecked] = useState([true,false,false])

    const widgetList = [ {'id':1, 'title':'Map', 'icon':'MdMap'},]
                        // {'id':2, 'title':'Map', 'icon':'MdMap'}, 
                        // {'id':3, 'title':'Analytics', 'icon':'MdAnalytics'}]

    const showHideModal = show
        ? 'block fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 modelIndex'
        : 'hidden'
    

    const handleAdd = () => {
        //post api
        setShow(false)

    }
    // useEffect(() => {
    //     if(show === false){
    //         setSelected(1)
    //         // setChecked([true,false,false])
    //     }
    // }, [show])
    

    return(
        <div className={showHideModal}>
            <section className="fixed transform -translate-y-1/2 -translate-x-1/2 top-2/4 left-2/4">
                <Card className="h-full w-80 md:w-full bg-white px-4 md:px-10 py-5 rounded-md filter drop-shadow-md top-2 bottom-2 right-2 left-2">
                    <p className="text-center font-bold text-xl">Add Widget</p>
                    <img 
                        className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60" 
                        onClick={() => setShow(false)} alt="cross" src={CROSS_GRAY_ICON}
                    />
                    <hr className='mt-3 border-gray-200'/>
                    <form className='grid grid-cols-3 gap-2 mt-5'>
                        {
                            widgetList.map((widget) => (
                                <WidgetOption 
                                    key={widget.id}
                                    widget={widget}
                                    setSelected={setSelected}                                    
                                />
                            ))
                        }      

                    </form>
              
                    {failed === true &&
                        <span className="cover-file-show-error text-red-500">Add post to showcase failed</span>
                    }
                    <div className="pt-5 flex justify-end">
                        {/* {addPostLoader 
                            ? <p className="font-semibold">Loading...</p>
                            : <ButtonBlue title="ADD" onClick={onClick} disabled={buttonDisabled}/>
                        } */}
                        
                        <ButtonBlue title="ADD" onClick={handleAdd} disabled={selected === undefined}/>
                    </div>
                    
                    
                </Card>
                
            </section>
        </div>
    )
} 

export default ModalWidget